angular.module('surfsightApp').factory('preventTemplateCache', function () {
  // console.log(webpackHash);
  return {
    //
    request: function (config) {
      console.log(JSON.stringify(config))
      /* if (config.url.indexOf('templates') !== -1) {
          config.url = config.url + '?t=' + webpackHash;
        } */
      return config
    }
  }
})
